import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getMonth/index.js';

var require$$24 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$24 as default };
